"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * BackEnd FrontEndで利用するtext...
 *
 */
exports.default = Object.freeze({
    en: {
        message: {
            hello: 'LGTM!'
        }
    },
    ja: {
        view: {
            hello: 'こんにちは、世界',
            footer: [{
                    title: "運営会社",
                    link: "http://rehabforjapan.jp/"
                }, {
                    title: "プライバシーポリシー",
                    link: "https://rehaplan.jp/service/privacy"
                }, {
                    title: "お問い合わせ",
                    link: "https://rehaplan.jp/service/feedback"
                }
            ],
            stop_covid_19: {
                title: '在宅リハビリコンテンツ',
            },
            verify: {
                button_caption: {
                    verify: 'メールアドレス認証',
                },
                username: 'ユーザーID',
                confirmation_code: '認証コード',
            },
            sign_up: {
                button_caption: {
                    sign_up: '登録',
                },
                username: 'ユーザーID',
            },
            login: {
                button_caption: {
                    login: 'ログイン'
                },
                username: 'メールアドレス',
                placeholder: {
                    username: '例）info@rehabforjapan.com'
                },
                hint: {
                    username: '申込時に記入したメールアドレスを入力してください'
                }
            },
            top: {
                message: [
                    '新型コロナウイルス感染症が拡大する中、自治体から要請を受けて、あるいは感染防止目的から自主的に休業している',
                    '通所介護事業所（デイサービス）が相次いでおります。',
                    ' ',
                    'デイサービスで行われているリハビリとは、高齢者の健康状態を維持、または改善するためのものです。',
                    '  ',
                    '人が集まったら感染リスクは高まる。',
                    '一方で、日々のリハビリを休止すれば、高齢者の健康状態は悪化し、介護レベルが進行する恐れがある。',
                    'このジレンマに、各デイサービスは苦慮されていることと思います。',
                    '   ',
                    '身体能力の低下を防ぐには、毎日少しずつでも適度な運動を続けることが大切です。',
                    'リハビリ専門職や機能訓練指導員による正しい介護リハビリが行えるに越したことはありません。',
                    'しかし、デイサービスにてリハビリを提供することが難しい状況においては、',
                    '利用者の介護予防、健康維持のために、最低限の運動を自宅でできるように利用者とその家族を',
                    'サポートすることが求められているのではないかと考えました。',
                    '    ',
                    'そこで、特設サイト「自宅でできる介護リハビリ」を開始いたします。',
                    'リハプラン契約事業所に限らず、希望者全員に一定期間、無償で提供いたします。'
                ],
                message_to_dayservice: [
                    'ご利用者やご家族に対して、ご利用者ごとのご事情に合わせて運動マニュアルをお渡しいただくなど、',
                    '在宅リハビリに対するサポートにぜひご活用ください。'
                ],
                message_to_all: [
                    '2,500種類、500セットの運動マニュアルの中には、ご自宅にはない器具を活用する運動や、',
                    '機能訓練指導員のサポートを前提とする少々難易度が高い運動も含まれております。',
                    '適切な運動の選択に悩まれる場合は、ご利用中のデイサービス事業所にご相談いただけますようお願いいたします。'
                ],
                content: [{
                        title: "提供サービス",
                        detail: [
                            '・目標や目的から運動を検索できるサービス',
                            '・約2,500種類の運動マニュアルを印刷できるサービス'
                        ]
                    }, {
                        title: "対象",
                        detail: [
                            '・デイサービスに通えていないご利用者およびご家族の皆様',
                            '・デイサービス、デイケア、訪問看護、訪問介護、居宅介護支援事業所などの介護従事者の皆様',
                            '　※リハプランご契約者様以外でもご利用可能です'
                        ]
                    }, {
                        title: "期間",
                        detail: [
                            '　2020年3月18日（水）〜<strike>2020年5月31日（日）</strike> 無期延期',
                            '　※想定以上の申込をいただき、提供期間終了日をコロナウイルス感染の一定収束が見込めるまでは無期限で延期いたします。'
                        ]
                    }, {
                        title: "申込方法",
                        detail: [
                            '　以下申込フォームよりお申し込みください'
                        ]
                    }, {
                        title: "利用料金",
                        detail: [
                            '　無料',
                            '　※無償提供期間終了後、有償サービスに自動的に移行することはございません。'
                        ]
                    }, {
                        title: "メディア掲載事例",
                        detail: [
                            '・経済産業省等が運営する新型コロナ対策支援情報サイト「#民間支援情報ナビ」(2020/03/27 )',
                            '・ケアマネジメント・オンライン（2020/04/02）',
                            '・小学館「介護ポストセブン」（2020/04/05）',
                            '・中日新聞「地域医療ソーシャルニュース」（2020/04/06）',
                            '・NHK「ひるまえほっと」（2020/04/07）',
                            '・日本経済新聞社「日経産業新聞」（2020/04/14 ）',
                            '・日経BP「日経BP Beyond Health」（2020/04/21）',
                            '・レバレジーズメディカルケア株式会社「きらっこノート」(2020/05/01)'
                        ]
                    }],
                notice: [
                    '※本無償サービスは無償期間の終了に伴い契約が終了し、有償サービスへ自動的に切り替わることはございません。',
                    '※提供機能や期間は、事前の告知なく変更することがございます。',
                    '※継続利用をご希望の方は別途ご相談ください。'
                ],
                service_description: [
                    'リハプランは、デイサービスの機能訓練業務を誰でも簡単・安心・効果的に行える「クラウド機能訓練ソフト」です。（個別機能訓練加算Ⅰ・個別機能訓練加算Ⅱ・運動器機能向上加算の3つの加算に対応しています。）',
                    '最新の高齢者データベースをもとに2,500種類の目標・運動プログラムから最適な計画・訓練を自動で提案。リハビリ業務に必要な全ての機能があり、職員の書類業務負担を軽減、介護事業所の差別化・売上アップを支援します。'
                ]
            },
            form: {
                button_caption: {
                    submit: '送信する'
                },
                validate_fail_message: '入力内容に誤りがございます。赤字箇所を修正して下さい。',
                title: '専用申込フォーム',
                title_top_message: '必要事項をご記入いただき、送信ボタンをクリックしてください',
                how_to_apply_title: '＜利用開始までの流れ＞',
                how_to_apply_step: [
                    '1.下記フォームよりお申込',
                    '2.登録完了メールの通知',
                    '3.特設サイトのログインページよりご利用開始'
                ],
                riyo_kiyaku: [
                    '【注意事項】',
                    '・「リハプラン」で保有している全運動マニュアルを公開しており、マシンや道具を利用した運動も含まれております。',
                    '・各運動マニュアルの難易度をご参考に、無理なく安全に実施できる運動マニュアルをご選択ください。',
                    '・心臓疾患などのご病気や怪我などがあり、実施できるリハビリに制限がある方の場合は、かかりつけ医や通われているデイサービスにご相談いただくことをおすすめいたします。',
                    '・弊社から提供する運動マニュアルによって、怪我や身体機能の悪化等が発生した場合において、弊社では一切の責任を負いかねますので予めご了承ください。'
                ],
                values: {
                    serviceType: [
                        'デイサービス',
                        'デイケア',
                        '居宅介護支援事業所',
                        '小規模多機能型居宅介護',
                        '訪問リハビリ',
                        '訪問看護',
                        '訪問介護',
                        '老人ホーム等施設',
                        'その他'
                    ],
                    other: 'その他',
                    jobType: [
                        '経営者',
                        '管理者',
                        '機能訓練指導員',
                        '介護職員',
                        '生活相談員',
                        '看護職員',
                        'メディア・行政関係者',
                        'その他'
                    ]
                },
                label: {
                    companyName: '会社名・所属団体名',
                    officeName: '事業所名',
                    serviceType: 'サービス種別',
                    address: '事業所住所',
                    tel: '事業所電話番号',
                    name: 'お名前',
                    email: 'メールアドレス',
                    jobType: 'ご職業/職種'
                },
                hint: {
                    companyName: '高齢者ご自身・ご家族様の場合は、ご利用の「デイサービス名」をご記載ください',
                    officeName: '高齢者ご自身・ご家族様の場合は、ご利用の「デイサービス名」をご記載ください',
                    serviceType: '',
                    address: '高齢者ご自身・ご家族様の場合は省略可能です',
                    tel: '高齢者ご自身・ご家族様の場合は省略可能です',
                    name: '',
                    email: '',
                    jobType: 'ご職業/職種',
                },
                placeholder: {
                    companyName: '例）株式会社 Rehab for JAPAN',
                    officeName: '例）リハブ事業所',
                    serviceType: '',
                    address: '例）東京都品川区西五反田8丁目8-15',
                    tel: '例）0367127770',
                    name: '例）リハブ 太郎',
                    email: '例）contact@rehabforjapan.com',
                    jobType: '',
                },
                errorMessage: {
                    companyName: '会社名・所属団体名は必須の項目です',
                    officeName: '事業所名は必須の項目です',
                    serviceType: 'サービス種別は必須の項目です',
                    address: '事業所住所は必須の項目です',
                    tel: '有効な事業所電話番号を入力してください',
                    name: 'お名前は必須の項目です',
                    email: '有効なメールアドレスを入力してください',
                    jobType: 'ご職業/職種は必須の項目です'
                }
            },
            exercise: {
                index_category: {
                    top_title: 'おすすめ運動マニュアル',
                    sum_title: 'どの運動マニュアルを選べば良いか分からない、ご病気や怪我などで実施できるリハビリに制限がある場合は、おすすめの運動マニュアルをお選びください',
                    categories: [
                        '筋力アップ',
                        'ストレッチ（拘縮予防）'
                    ]
                },
                caption: [
                    '約2,500種類、500セットの運動マニュアルを、さまざまな運動目標・目的からお選びいただけます。'
                ],
                index: {
                    button_caption: {
                        search: '運動を検索する'
                    },
                    icon_caption: {
                        osusume: 'おすすめ'
                    },
                    search_input: '運動分類を選択',
                    search_items_data: [
                        {
                            category: '健康の維持',
                            item: [
                                { text: '筋力アップ', value: 3001 },
                                { text: '体力づくり', value: 3003 },
                                { text: 'ストレッチ', value: 3002 },
                                { text: '姿勢改善', value: 3009 },
                                { text: 'むくみ予防', value: 3007 },
                                { text: '尿もれ予防', value: 3008 },
                                { text: '誤嚥予防', value: 3004 },
                                { text: '転倒予防', value: 3005 }
                            ]
                        },
                        {
                            category: '病気・痛みの予防',
                            item: [
                                { text: 'パーキンソン', value: 3012 },
                                { text: '呼吸機能改善', value: 3017 },
                                { text: '変形性股関節症', value: 3014 },
                                { text: '変形性膝関節症', value: 3015 },
                                { text: '認知機能', value: 3010 },
                                { text: '大腿骨頸部骨折', value: 3013 },
                                { text: '腰椎圧迫骨折', value: 3016 },
                                { text: '脳卒中（片麻痺）', value: 3011 },
                                { text: '疼痛予防', value: 3006 }
                            ]
                        },
                        {
                            category: '寝返り・乗り移り',
                            item: [
                                { text: '基本動作', value: 2002 },
                                { text: '移乗', value: 2009 },
                                { text: '床上動作', value: 2003 }
                            ]
                        },
                        {
                            category: '日常生活',
                            item: [
                                { text: 'トイレ', value: 2005 },
                                { text: '入浴', value: 2006 },
                                { text: '更衣', value: 2007 },
                                { text: '整容', value: 2008 },
                                { text: '食事', value: 2004 },
                                { text: '自宅内移動', value: 2010 }
                            ]
                        },
                        {
                            category: 'その他',
                            item: [
                                { text: '料理', value: 2014 },
                                { text: '洗濯', value: 2015 },
                                { text: '掃除', value: 2016 },
                                { text: '買い物', value: 2018 },
                                { text: '金銭管理', value: 2019 },
                                { text: '服薬管理', value: 2017 },
                                { text: '自宅外移動', value: 2011 },
                                { text: '階段昇降', value: 2012 },
                                { text: '公共交通機関', value: 2013 },
                                { text: '趣味活動', value: 2020 }
                            ]
                        },
                    ],
                    search_items: [
                        '筋力アップ',
                        'ストレッチ（拘縮予防）',
                        '体力づくり',
                        '誤嚥予防',
                        '転倒予防',
                        '肩痛予防',
                        '腰痛予防（圧迫骨折なし）',
                        '膝痛予防',
                        'むくみ予防',
                        '尿もれ予防',
                        '姿勢改善',
                        '生活リズム',
                        '認知機能',
                        '脳卒中（片麻痺）',
                        'パーキンソン',
                        '大腿骨頸部骨折',
                        '変形性股関節症',
                        '変形性膝関節症',
                        '腰椎圧迫骨折',
                        '呼吸機能改善'
                    ]
                }
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./common/src/constrains/locale/texts.ts
// module id = WQ+C
// module chunks = 1